import React, { useState, useEffect, useCallback } from 'react';
import { Alert, Typography, Card, Button } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import styles from '../../styles/login.module.scss';
import { AuthAPI } from '../../api/auth-api';

const { Title } = Typography;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ChangePassword = () => {
  const [error, setError] = useState('');
  const query = useQuery();
  const email = query.get('email');
  const navigate = useNavigate();

  const handleResend = useCallback(async () => {
    const { success, message } = await AuthAPI.forgotPassword({ email });

    if (!success) {
      setError(message);
    }
  }, [email]);

  // The previous page already sent the email; this page only offers a manual resend.
  useEffect(() => {
    if (!email) {
      navigate('/');
    }
  }, [email, navigate]);

  return (
    <div className={styles.login}>
      <div className={styles.login__left}>
        <div className={styles.login__logo}>
          <Link to="/">
            <img src="/logo.svg" alt="Logo" height={30} width={100} />
          </Link>
        </div>
        <div className={styles.login__formCard}>
          <Card className={styles.login__card}>
            <Title className={styles.login__title} level={1}>
              Promenite šifru
            </Title>
            <p>
              Link za promenu šifre je poslat na <strong>{email}</strong>.
              Molimo vas da proverite vašu email adresu i pratite uputstva za
              promenu šifre.
            </p>
            <p>
              Nije vam stigao email? Pritisnite na dugme ispod{' '}
              <strong>“Pošalji ponovo”</strong> kako biste poslali novi zahtev.
            </p>

            {error && (
              <Alert
                message={error}
                type="error"
                showIcon
                style={{ marginBottom: 16 }}
              />
            )}

            <Button
              className="btn-tertiary btn-repeat"
              onClick={handleResend}
              style={{ width: '100%' }}
            >
              Pošalji ponovo
            </Button>
            <br />
            <br />
            <Button
              className="btn-tertiary btn-no-border-hover"
              onClick={() => window.history.back()}
              style={{ width: '100%' }}
            >
              Odustani
            </Button>
          </Card>
        </div>
      </div>
      <div className={styles.login__right}></div>
    </div>
  );
};

export default ChangePassword;
